import { Field } from 'formik';
import { AccordionItem, AccordionPanel, Stack, Box } from '@chakra-ui/react';
import { Select as NumberSelect } from 'chakra-react-select';
import {
    FormControl,
    FormLabel,
    FormErrorMessage,
    Input,
} from '@/components/v4';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
    dropDownFormStyle,
    textBoxStyling,
} from 'components/forms/new/formStyles';
import RingGroupAccordionSectionButton from './RingGroupAccordionSectionButton';

export default function RingGroupDetailsSection({
    errors,
    touched,
    values,
    setFieldValue,
    sites,
    isSingleSite,
    darkMode,
    panelBg,
    accordionBorderColor,
}) {
    return (
        <AccordionItem
            borderColor={accordionBorderColor}
            mb={2}
            borderWidth="1px"
            borderRadius="md"
            overflow="hidden">
            <RingGroupAccordionSectionButton darkMode={darkMode}>
                Ring Group Details
            </RingGroupAccordionSectionButton>
            <AccordionPanel px={4} py={4} bg={panelBg}>
                <Stack spacing={1}>
                    {/* Name */}
                    <FormControl
                        sx={{ margin: '0 !important' }}
                        isInvalid={!!errors.name && touched.name}>
                        <Stack
                            direction="row"
                            spacing={stackSpacing}
                            sx={stackStyling()}>
                            <FormLabel sx={formLabelStyling(darkMode)}>
                                Name <span style={{ color: '#e53e3e' }}>*</span>
                            </FormLabel>
                            <Box flex="1" pt="15px">
                                <Field name="name">
                                    {({ field }) => (
                                        <Input
                                            {...field}
                                            placeholder="Ring Group Name"
                                            sx={textBoxStyling}
                                        />
                                    )}
                                </Field>
                            </Box>
                        </Stack>
                        <FormErrorMessage>{errors.name}</FormErrorMessage>
                    </FormControl>

                    {/* Site */}
                    <FormControl sx={{ margin: '0 !important' }}>
                        <Stack
                            direction="row"
                            spacing={stackSpacing}
                            sx={stackStyling()}>
                            <FormLabel sx={formLabelStyling(darkMode)}>
                                Site
                            </FormLabel>
                            <Box flex="1" pt="15px">
                                {isSingleSite ? (
                                    <Input
                                        isReadOnly
                                        isDisabled
                                        value={sites[0].name}
                                        sx={textBoxStyling}
                                    />
                                ) : (
                                    <NumberSelect
                                        options={sites}
                                        value={
                                            sites.find(
                                                (s) => s.id === values.siteId,
                                            ) || null
                                        }
                                        getOptionLabel={(s) => s.name}
                                        getOptionValue={(s) => s.id}
                                        onChange={(s) =>
                                            setFieldValue('siteId', s?.id || '')
                                        }
                                        placeholder="Select a site"
                                        chakraStyles={dropDownFormStyle(
                                            darkMode,
                                        )}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                        }}
                                    />
                                )}
                            </Box>
                        </Stack>
                    </FormControl>

                    {/* Extension */}
                    <FormControl
                        sx={{ margin: '0 !important' }}
                        isInvalid={
                            !!errors.platformExtension &&
                            touched.platformExtension
                        }>
                        <Stack
                            direction="row"
                            spacing={stackSpacing}
                            sx={stackStyling()}>
                            <FormLabel sx={formLabelStyling(darkMode)}>
                                Extension
                            </FormLabel>
                            <Box flex="1" pt="15px">
                                <Field name="platformExtension">
                                    {({ field }) => (
                                        <Input
                                            {...field}
                                            placeholder="Extension"
                                            sx={textBoxStyling}
                                        />
                                    )}
                                </Field>
                            </Box>
                        </Stack>
                        <FormErrorMessage>
                            {errors.platformExtension}
                        </FormErrorMessage>
                    </FormControl>
                </Stack>
            </AccordionPanel>
        </AccordionItem>
    );
}
